import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompaniesComponent } from './companies.component';
import { AuthGuardService as AuthGuard } from './../../auth-guard.service';
import { NewCompanyComponent } from './new-company/new-company.component';

const routes: Routes = [
  {path: 'company', component: CompaniesComponent, canActivate: [AuthGuard]},
  {path: 'company/create-edit', component: NewCompanyComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompaniesRoutingModule { }
